import { Empty, Form, Select, Button, Popover, Tooltip } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setTipoOp } from "../../store/tipoOpActions";
import { setFocus } from "../../store/actions";
import { setSafra } from "../../store/safraActions";
import { setCultura } from "../../store/culturaActions";
import { ativarProcess } from "../../store/actions";
import { IFazenda } from "../../reducers/FazendaReducer";
import {
    ISafra,
    ISafraClienteList,
    ISafraList,
} from "../../reducers/SafraReducer";
import { IMenu } from "../../reducers/MenuReducer";
import { v4 as uuidv4 } from "uuid";
import { IStore } from "../../store";
import { IProcessList } from "../../reducers/ProcessReducer";
import { IPreferencia } from "../../reducers/PreferenciaReducer";
import { IStatusList } from "../../store/types";
import { getEquipamentoListFiltro } from "../../store/polylineAction";
import { ITime } from "../../reducers/TimeReducer";
import { ITheme } from "../../reducers/ThemeReducer";

const { Option } = Select;
export interface ISafraController {
    fazenda: IFazenda;
    safras: ISafraList;
    menuState: IMenu;
    processListState: IProcessList;
    setTipoOp: Function;
    ativarProcess: Function;
    setCultura: Function;
    setFocus: Function;
    setSafra: Function;
    prefs: IPreferencia;
    loader: IStatusList;
    getEquipamentoListFiltro: Function;
    time: ITime;
    tema: ITheme;

    safraList: ISafraClienteList;
}
export function SafraController(props: ISafraController) {
    const { fazenda, setFocus, safras, setSafra, tema, safraList } = props;
    function handleChangeSafra(value: any) {
        if (value === "all") {
            setFocus({ view: 7, subview: null });
            setSafra({});
        } else if (value === "naoIdentificado") {
            setFocus({ view: 7, subview: null });
            setSafra({ id_safra: 0 });
        } else {
            setFocus({ view: 7, subview: null });
            setSafra(
                safras[safras.findIndex((s: ISafra) => s.id_safra === value)]
            );
        }
        // ativarProcess({
        //     menuItem: menuState[menuState.findIndex(m => m.id === 6)],
        //     processList: processListState,
        // });
        // setFocus(3);
    }

    const filteredSfrOptions = safras.filter((o: any) =>
        safraList.some((s: any) => s.safra_temp === o.id_safra)
    );

    return (
        <>
            <Form>
                <Form.Item
                    name="safra"
                    label={
                        <span
                            style={{
                                color: tema ? "#fff" : "#606060",
                                paddingLeft: "2px",
                                fontSize: "18px",
                            }}
                        >
                            <Tooltip title="Safra">
                                <i className="fas fa-stopwatch"></i>
                            </Tooltip>
                        </span>
                    }
                    colon={false}
                >
                    <Select
                        style={{
                            width: 200,
                            color: tema ? "#fff" : "#606060",
                            border: "1px solid #C1C1C1",
                            backgroundColor: tema ? "#757575" : "",
                        }}
                        size="small"
                        disabled={fazenda.id_fazenda === ""}
                        bordered={false}
                        placeholder="Escolha"
                        //optionLabelProp="label"
                        suffixIcon={<i className="fas fa-chevron-right"></i>}
                        // notFoundContent={
                        //     <Empty
                        //         description="Nenhuma operação foi carregada."
                        //         image={Empty.PRESENTED_IMAGE_SIMPLE}
                        //     />
                        // }
                        //dropdownRender={menu => <div>{menu}</div>}
                        onChange={handleChangeSafra}
                        onSelect={handleChangeSafra}
                        dropdownClassName="agrochip-dropdown"
                    >
                        {filteredSfrOptions.length > 0 ? (
                            <>
                                <Option
                                    value="all"
                                    label="Todos"
                                    key={uuidv4()}
                                >
                                    <div
                                        style={{
                                            display: "flex",

                                            flexDirection: "column",
                                        }}
                                    >
                                        <div>Todas as safras</div>
                                    </div>
                                </Option>

                                {filteredSfrOptions.map((e: any) => {
                                    return (
                                        <Option
                                            value={e.id_safra}
                                            key={e.id_safra}
                                        >
                                            {e.descricao}
                                        </Option>
                                    );
                                })}

                                <Option
                                    value="naoIdentificado"
                                    label="Não Identificado"
                                    key={uuidv4()}
                                >
                                    <div
                                        style={{
                                            display: "flex",

                                            flexDirection: "column",
                                        }}
                                    >
                                        <div>Não Identificado</div>
                                    </div>
                                </Option>
                            </>
                        ) : (
                            <Option disabled>
                                <div
                                    style={{
                                        display: "flex",

                                        flexDirection: "column",
                                    }}
                                >
                                    {" "}
                                    <div
                                        style={{
                                            flex: 1,
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Não há nenhuma safra cadastrada.
                                    </div>
                                </div>
                            </Option>
                        )}
                    </Select>
                </Form.Item>
            </Form>
        </>
    );
}

function mapStateToProps(store: IStore) {
    return {
        fazenda: store.fazenda,
        tipoOps: store.tiposOp,
        menuState: store.menu,
        processListState: store.processos,
        safras: store.safras,
        culturas: store.culturas,
        prefs: store.preferencia,
        loader: store.loader,
        time: store.time,
        tema: store.theme,

        safraList: store.safrasCliente,
    };
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators(
        {
            setTipoOp,
            setCultura,
            setSafra,
            ativarProcess,
            setFocus,
            getEquipamentoListFiltro,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SafraController);
